import { createFileRoute } from "@tanstack/react-router";
import DiagnosedDepressionAt60 from "@/pages/articles/DiagnosedDepressionAt60";
export const Route = createFileRoute("/diagnosed-with-depression-at-60")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Diagnosed With Depression At 60 | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression at 60 is not a normal part of aging. Learn about TMS, SAINT TMS, and treatment options for depression in your 60s in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Diagnosed With Depression At 60 | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression at 60 is not a normal part of aging. Learn about TMS, SAINT TMS, and treatment options for depression in your 60s in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/diagnosed-with-depression-at-60",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/diagnosed-with-depression-at-60",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DiagnosedDepressionAt60 />;
}
